import {Component, computed, inject, input} from '@angular/core';
import {Cart} from '@core/interfaces/generated/graphql';
import {CurrencyPipe} from '@angular/common';
import {formatPrice} from '@core/pipes/price.pipe';
import {GroupVoucherService} from '@core/services/groupVoucher.service';
import {StoreConfigService} from '@core/services/store-config.service';

@Component({
  selector: 'app-free-shipping-incentive',
  templateUrl: './free-shipping-incentive.component.html',
  styleUrls: ['./free-shipping-incentive.component.scss'],
  imports: [
    CurrencyPipe
  ]
})

export class FreeShippingIncentiveComponent {
  private groupVoucherService = inject(GroupVoucherService);
  private storeConfigService = inject(StoreConfigService);


  cart = input<Cart>();

  currencyCode = this.storeConfigService.currencyCode;

  showFreeDeliveryText() {
    return computed(() => {
      const cart = this.cart();
      if (!cart) {
        return false;
      }
      const groupVoucher = this.groupVoucherService.groupVoucherSignal()
      if (groupVoucher.groupVoucher?.delivery) {
        return false;
      }
      return this.untilFreeDelivery(cart) > 0 && this.isCartNotEmpty(cart) && this.cartIsNotVirtual(cart);
    });
  }

  isCartNotEmpty(cart: Cart) {
    return (cart.items?.length || 0) > 0;
  }

  cartIsNotVirtual(cart: Cart) {
    return !cart.isVirtual;
  }

  untilFreeDelivery(cart: Cart | undefined): number {
    const freeDelivery = this.storeConfigService.storeConfig()?.freeDeliveryStartsFrom || 0;
    if (!cart?.totalPrice) {
      return freeDelivery;
    }
    return freeDelivery - formatPrice(cart.totalPrice - (cart.shippingMethod?.price || 0));
  }
}
